import React from 'react';

/* ═══════════════════════════════════════════════════════════════
   STEP ICONS — replaces the three Lottie players in WelcomeModal.

   Why this file exists: the previous icons were Lottie animations
   loaded from ./lottie/welcomeAnimations. When that animation data
   is missing/undefined, `lottie-react` doesn't throw — it silently
   renders its internal SVG player shell with nothing drawn inside,
   which is the "unmatched inner circle" artifact visible in the
   disc (a stray dot floating in an empty ring).

   These are plain, static SVGs: no async load, no missing-asset
   failure mode, no per-device animation cost. Each icon is drawn
   on a 24×24 grid, single stroke weight, currentColor — so they
   inherit color from CSS and never need a hex value baked in.
═══════════════════════════════════════════════════════════════ */

const strokeProps = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.6,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

/* 01 — Discover: a search glass, with the "lens" standing in for
   a plate — searching by taste, not scrolling a menu list. */
export const DiscoverIcon = (props) => (
  <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" {...props}>
    <circle cx="10.5" cy="10.5" r="6.25" {...strokeProps} />
    <circle cx="10.5" cy="10.5" r="2.15" {...strokeProps} strokeWidth="1.3" />
    <path d="M15.1 15.1 L20 20" {...strokeProps} />
  </svg>
);

/* 02 — Order: a single tap ripple over a check — one confirmed
   action starts the kitchen, nothing more to fill in. */
export const OrderIcon = (props) => (
  <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" {...props}>
    <circle cx="12" cy="12" r="6.25" {...strokeProps} />
    <path d="M9.1 12.15 L11.15 14.2 L15.1 9.9" {...strokeProps} />
    <path d="M12 3.4 V5.4" {...strokeProps} opacity="0.55" />
    <path d="M12 18.6 V20.6" {...strokeProps} opacity="0.55" />
    <path d="M3.4 12 H5.4" {...strokeProps} opacity="0.55" />
    <path d="M18.6 12 H20.6" {...strokeProps} opacity="0.55" />
  </svg>
);

/* 03 — Ready: a plate set with fork and knife — the table is set
   the moment you sit down, no queue in between. */
export const ReadyIcon = (props) => (
  <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" {...props}>
    <circle cx="12.75" cy="12" r="6.1" {...strokeProps} />
    <circle cx="12.75" cy="12" r="2.6" {...strokeProps} strokeWidth="1.3" />
    <path d="M4.4 6.4 V11.2 C4.4 12.1 5 12.6 5.7 12.6" {...strokeProps} />
    <path d="M5.7 6.4 V12.6" {...strokeProps} />
    <path d="M4.4 6.4 V9.2" {...strokeProps} />
    <path d="M5.7 12.6 V17.6" {...strokeProps} />
  </svg>
);

/* Ordered export so the modal can map over one array, same as the
   old STEPS[].anim did. */
export const STEP_ICONS = [DiscoverIcon, OrderIcon, ReadyIcon];